import script from "./ProVenueDescriptionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProVenueDescriptionDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProVenueDescriptionDialog.vue?vue&type=style&index=0&id=ebcfa726&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebcfa726"]])

export default __exports__